const HEADING_SELECTOR = ".prose-block :is(h2,h3,h4,h5,h6)[id]"
const TOUCH_QUERY = "(hover: none), (pointer: coarse)"

const linkIcon = `
  <svg class="heading-anchor__icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true" focusable="false">
    <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
  </svg>
`

const absoluteAnchorUrl = (id) => {
  const url = new URL(window.location.href)
  url.hash = id
  return url.toString()
}

const copyToClipboard = async (url) => {
  if (!navigator.clipboard?.writeText) return false

  try {
    await navigator.clipboard.writeText(url)
    return true
  } catch {
    return false
  }
}

const isPlainPrimaryActivation = (event) =>
  event.button === 0 &&
  !event.metaKey &&
  !event.ctrlKey &&
  !event.shiftKey &&
  !event.altKey

const positionStatus = (anchor, status) => {
  const gap = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue("--space-2")) || 8
  const anchorBox = anchor.getBoundingClientRect()
  const headingBox = anchor.parentElement.getBoundingClientRect()

  status.style.left = `${anchorBox.right - headingBox.left + gap}px`
  status.style.top = `${anchorBox.top - headingBox.top + (anchorBox.height / 2)}px`
}

const showStatus = (anchor, status, text) => {
  window.clearTimeout(anchor.headingAnchorTimer)
  positionStatus(anchor, status)
  anchor.classList.add("is-copied")
  status.classList.add("is-visible")
  status.textContent = text

  anchor.headingAnchorTimer = window.setTimeout(() => {
    anchor.classList.remove("is-copied")
    status.classList.remove("is-visible")
    status.textContent = ""
  }, 1500)
}

const handleHeadingTap = (heading) => {
  if (!window.matchMedia(TOUCH_QUERY).matches) return

  heading.addEventListener("click", (event) => {
    if (event.target.closest("a, button, input, select, textarea")) return

    window.location.hash = heading.id
  })
}

const enhanceHeading = (heading) => {
  if (heading.querySelector(":scope > .heading-anchor")) return

  const anchor = document.createElement("a")
  anchor.className = "heading-anchor"
  anchor.href = `#${encodeURIComponent(heading.id)}`
  anchor.setAttribute("aria-label", "Copy link to this section")
  anchor.innerHTML = linkIcon

  const status = document.createElement("span")
  status.className = "heading-anchor__status"
  status.setAttribute("aria-live", "polite")
  status.setAttribute("aria-atomic", "true")

  anchor.addEventListener("click", async (event) => {
    const url = absoluteAnchorUrl(heading.id)

    if (!window.matchMedia(TOUCH_QUERY).matches && isPlainPrimaryActivation(event)) {
      event.preventDefault()
      history.replaceState(null, "", `#${encodeURIComponent(heading.id)}`)
    }

    const copied = await copyToClipboard(url)
    showStatus(anchor, status, copied ? "Copied" : "Link ready")
  })

  heading.append(anchor)
  heading.append(status)
  handleHeadingTap(heading)
}

const enhanceHeadingAnchors = () => {
  document.querySelectorAll(HEADING_SELECTOR).forEach(enhanceHeading)
}

document.addEventListener("DOMContentLoaded", enhanceHeadingAnchors)
